import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { ApiQueryParams, ResponseObjectList } from "../../entities/global";
import { CoinEntity, CoinProfile } from "../../entities/coinGame";

const coinGameUrl = apiUrlV1 + "/v2/organization/game/coin-flip";

/**
 * Получение списка игр Coin Flip
 */
export const getCoinEntityList = createAsyncThunk(
  "coin/get-entity-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<CoinEntity[]>> => {
    try {
      const query = encodeGetParams({ ...params })
      const response = await agent.get(`${coinGameUrl}/read/list${query}`);
      if (response.ok) {
        const data = (await response.json()) as ResponseObjectList<CoinEntity[]>;
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: []
    };
  }
);
/**
 * Удаление игры по ID
 * @param {number} id - ID игры для удаления.
 * После удаления игры срабатывает чанк на загрузку списка игр. {@link any()}
 */
export const deleteCoinEntity = createAsyncThunk(
  'coin/delete-entity',
  async (param: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${coinGameUrl}/delete/${param.id}`)
      if (response.ok) {
        thunksApi.dispatch(getCoinEntityList());
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

/**
 * Получение списка профилей игры Coin Flip
 */
export const getCoinProfilesList = createAsyncThunk(
  "coin/get-profile-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<CoinProfile[]>> => {
    try {
      const query = encodeGetParams({ ...params })
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/coinFlip/list${query}`);
      if (response.ok) {
        const data = (await response.json()) as ResponseObjectList<CoinProfile[]>;
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: []
    };
  }
);

/**
 * Удаление профиля по ID
 * @param {number} id - ID профиля для удаления.
 * После удаления ппрофиля срабатывает чанк на загрузку списка игр. {@link CoinProfile()}
 */
export const deleteCoinProfile = createAsyncThunk(
  'coin/delete-profile',
  async (param: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${coinGameUrl}/profile/delete/${param.id}`)
      if (response.ok) {
        thunksApi.dispatch(getCoinProfilesList());
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)